<template>
  <section class="container message">
    <div class="message-inner">
      <ul class="message-wrapper clearfix">
        <li class="message-item photo">
          <div class="item-inner">
            <div class="img-box" ref="messageImageBox">
              <img src="../../../assets/about/KakaoTalk_20241118_152920112.jpg" alt="" id="messageImage" ref="messageImage" :style="{scale: pastorImageScale}">
              <div class="overlay"></div>

            </div>
          </div>
        </li>
        <li class="message-item content" ref="messageItemContent">
          <div class="item-inner">
            <h3 class="pc">
              <span>천호제일교회 젊은이부 <span style="color: #00c5e3; font-weight: 700">AXIS</span>을</span><br>
              <span class="bold-text" style="font-weight: 700">방문해주셔서 감사합니다!</span><br>
            </h3>
            <h3 class="mobile">
              <span>천호제일교회 젊은이부 <span style="color: #00c5e3; font-weight: 700">AXIS</span>을</span><br>
              <span class="bold-text" style="font-weight: 700">방문해주셔서 감사합니다!</span>
            </h3>
            <p>
<!--              사랑하는 AXIS 가족 여러분, 주님의 이름으로 여러분을 진심으로 환영합니다!<br><br>-->
              AXIS라는 이름은 예수 그리스도께서 우리 교회의 중심이 되심을 상징하며, 그분의 복음을 위해 살아가는 우리 삶의 방향을 나타냅니다. 우리는 이 축을 통해 하나님의 나라를 세우고, 예수님을 우리의 삶의 중심에 모시며, 그분의 뜻을 이루어가기를 소망합니다.<br><br>
              우리의 목표는 세상의 유혹과 혼란 속에서도 흔들리지 않고, 예수님을 우리의 AXIS, 즉 중심으로 삼아 믿음의 길을 걸어가는 것입니다. 하나님의 나라를 이 땅에 이루는 축으로서의 역할을 감당하며, 그분의 복음을 땅끝까지 전파하는 사명에 헌신하는 공동체로서 함께 성장해 나가기를 바랍니다.<br><br>
              AXIS의 축이 되시는 예수 그리스도를 통해 우리 모두가 하나님의 나라를 이 땅에 이루어 가는 사명에 동참할 수 있기를 바랍니다. 여러분을 주님의 사랑으로 다시 한번 환영하며 축복합니다!<br><br>
              감사합니다.
            </p>
            <h4 class="do-hyeon-regular pc">천호제일감리교회 젊은이부 담당목사 최진봉</h4>
            <h4 class="do-hyeon-regular mobile">
              천호제일감리교회 젊은이부<br>
              담당목사 최진봉
            </h4>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "Greeting",
  props: {
    pastorImageScale: {
      type: Number,
      default: 1
    },
    handleIntersect: {
      type: Function
    }
  },

  mounted() {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -150px 0px',  // 뷰포트 하단에서 200px 지나야만 트리거
      threshold: 0  // 요소의 30%가 보일 때 트리거
    };

    const ScrollObserverOptions = {
      root: null,
      threshold: .7
    };

    const scrollObserver = new IntersectionObserver(this.handleIntersect, ScrollObserverOptions);
    // 감시할 섹션 요소 추가
    scrollObserver.observe(this.$refs.messageImage);

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 요소가 보이면 isVisible을 true로 설정
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    observer.observe(this.$refs.messageImageBox);
    observer.observe(this.$refs.messageItemContent);
  },
}
</script>



<style scoped lang="scss">
.message {

  padding-bottom: 160px;

  .message-wrapper {

    box-sizing: border-box;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    margin-top: 140px;

    .message-item {

      float: left;
      box-sizing: border-box;
      padding: 10px;

      &:first-child {
        width: 40%;
      }
      &:last-child {

        width: 60%;
        text-align: left;

        transform: translateX(200px);
        transition: all .5s ease-out;

        &.visible {
          transform: translateX(0);
        }

        h3 {
          margin-top: 15px;
          font-size: 30px;
          color: #333;
          line-height: 1.4;

          &.pc {
            display: block;

            .bold-text {
              font-size: 34px;
            }
          }

          &.mobile {
            display: none;
          }

          span {
            font-weight: 300;
          }
        }

        h4 {
        }

        p {
          line-height: 1.4;
          font-size: 16px;
          margin-top: 40px;
        }

        h4 {
          margin-top: 30px;
          font-size: 20px;
          color: #333;

          &.pc {
            display: block;
          }

          &.mobile {
            display: none;
          }
        }
      }

      .item-inner {
        position: relative;
        .img-box {

          width: fit-content;
          //height: 600px;
          overflow: hidden;

          transform: translateX(-20px);
          transition: all .7s ease;
          border-radius: 5px;

          &.visible {
            transform: translateX(0);

            img {
              width: 100%;
            }
          }

          img {
            border-radius: 5px;
            transition: scale 2s ease;
          }

          .overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            //background-color: rgba(0, 0, 0, .3);
          }
        }

        &:last-child {
          padding-left: 40px;
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .message .message-wrapper {
    padding: 15px;
    margin-top: 60px;

  }

  .message .message-wrapper .message-item:last-child h3 {
    font-size: 26px;
  }

  .message .message-wrapper .message-item:last-child h3.pc .bold-text {
    font-size: 30px;
  }

  .message .message-wrapper .message-item:last-child h3 span {
    font-size: 26px;
  }

  .message .message-wrapper .message-item .item-inner .img-box {
    height: fit-content;
  }

  .message .message-wrapper .message-item .item-inner .img-box img {
    width: 100%;
  }

  .message .message-wrapper .message-item .item-inner:last-child {
    padding: 10px;
  }

}

@media screen and (max-width: 768px) {

  .message {
    padding-bottom: 60px;
  }

  .message .message-wrapper {
    padding: 15px;
    overflow: hidden;
    margin-top: 20px;
  }

  .message .message-wrapper .message-item:first-child {
    width: 100%;
  }

  .message .message-wrapper .message-item:last-child {
    width: 100%;
  }

  .message .message-wrapper .message-item:last-child h3.mobile {
    display: block;
    font-weight: 300;
    margin-top: 0;
  }

  .message .message-wrapper .message-item:last-child h3.pc {
    display: none;
  }

  .message .message-wrapper .message-item:last-child h3 span {
    font-size: 23px;
  }

  .message .message-wrapper .message-item:last-child h3 span.bold-text {
    font-size: 26px;
  }

  .message .message-wrapper .message-item:last-child h4.pc {
    display: none;
  }

  .message .message-wrapper .message-item:last-child h4.mobile {
    display: block;
    line-height: 1.4;
  }

  .message .message-wrapper .message-item:last-child p {
    font-size: 15px;
  }

}

</style>